/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ResourceValidationError } from '../models/ResourceValidationError';

export class BatchResourceValidationResult {
  /**
  * The resource ID that was validated
  */
  'resourceId': string;
  /**
  * The display name of the resource
  */
  'resourceName'?: string;
  /**
  * Whether the resource configuration is valid
  */
  'isValid': boolean;
  /**
  * List of configuration validation errors (empty array if valid)
  */
  'errors': Array<ResourceValidationError>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "resourceId",
      "baseName": "resourceId",
      "type": "string",
      "format": ""
    },
    {
      "name": "resourceName",
      "baseName": "resourceName",
      "type": "string",
      "format": ""
    },
    {
      "name": "isValid",
      "baseName": "isValid",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "errors",
      "baseName": "errors",
      "type": "Array<ResourceValidationError>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BatchResourceValidationResult.attributeTypeMap;
  }

  public constructor() {
  }
}

